import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { PortalAuthProvider } from "@/contexts/PortalAuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PortalProtectedRoute from "@/components/PortalProtectedRoute";
import Layout from "@/components/Layout";
import PortalLayout from "@/components/PortalLayout";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import DomainsPage from "@/pages/DomainsPage";
import ServicesPage from "@/pages/ServicesPage";
import TasksPage from "@/pages/TasksPage";
import TeamPage from "@/pages/TeamPage";
import StudentsPage from "@/pages/StudentsPage";
import LessonsPage from "@/pages/LessonsPage";
import GoogleAdsPage from "@/pages/GoogleAdsPage";
import GoogleAdsAccountPage from "@/pages/GoogleAdsAccountPage";
import TicketsPage from "@/pages/TicketsPage";
import TicketDetailPage from "@/pages/TicketDetailPage";
import MessagesPage from "@/pages/MessagesPage";
import NotificationsPage from "@/pages/NotificationsPage";
import FinancePage from "@/pages/FinancePage";
import MeetingsPage from "@/pages/MeetingsPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import CalendarPage from "@/pages/CalendarPage";
import OnboardingPage from "@/pages/OnboardingPage";
import NotesPage from "@/pages/NotesPage";

import AiToolsIndexPage from "@/pages/ai-tools/AiToolsIndexPage";
import KeywordToolPage from "@/pages/ai-tools/KeywordToolPage";
import KeywordNewJobPage from "@/pages/ai-tools/KeywordNewJobPage";
import KeywordJobDetailPage from "@/pages/ai-tools/KeywordJobDetailPage";
import KeywordListsPage from "@/pages/ai-tools/KeywordListsPage";
import KeywordListDetailPage from "@/pages/ai-tools/KeywordListDetailPage";
import AdCopyToolPage from "@/pages/ai-tools/AdCopyToolPage";
import AdCopyNewPage from "@/pages/ai-tools/AdCopyNewPage";
import AdCopyJobDetailPage from "@/pages/ai-tools/AdCopyJobDetailPage";
import IndexBoostPage from "@/pages/ai-tools/IndexBoostPage";
import ReportBuilderPage from "@/pages/ReportBuilderPage";

import PortalLoginPage from "@/pages/portal/PortalLoginPage";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalServiceDetail from "@/pages/portal/PortalServiceDetail";
import PortalFiles from "@/pages/portal/PortalFiles";
import PortalSupport from "@/pages/portal/PortalSupport";
import PortalTicketDetail from "@/pages/portal/PortalTicketDetail";
import PortalKeywords from "@/pages/portal/PortalKeywords";
import PortalReports from "@/pages/portal/PortalReports";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Internal */}
        <Route path="/login" element={
          <AuthProvider><LoginPage /></AuthProvider>
        } />
        <Route path="/*" element={
          <AuthProvider>
            <Routes>
              <Route path="/" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
              <Route path="/musteriler" element={<ProtectedRoute><Layout><CustomersPage /></Layout></ProtectedRoute>} />
              <Route path="/musteriler/:cid" element={<ProtectedRoute><Layout><CustomerDetailPage /></Layout></ProtectedRoute>} />
              <Route path="/hizmetler" element={<ProtectedRoute><Layout><ServicesPage /></Layout></ProtectedRoute>} />
              <Route path="/gorevler" element={<ProtectedRoute><Layout><TasksPage /></Layout></ProtectedRoute>} />
              <Route path="/domainler" element={<ProtectedRoute><Layout><DomainsPage /></Layout></ProtectedRoute>} />
              <Route path="/google-ads" element={<ProtectedRoute requireAdmin><Layout><GoogleAdsPage /></Layout></ProtectedRoute>} />
              <Route path="/google-ads/:accountId" element={<ProtectedRoute requireAdmin><Layout><GoogleAdsAccountPage /></Layout></ProtectedRoute>} />
              <Route path="/ogrenciler" element={<ProtectedRoute><Layout><StudentsPage /></Layout></ProtectedRoute>} />
              <Route path="/dersler" element={<ProtectedRoute><Layout><LessonsPage /></Layout></ProtectedRoute>} />
              <Route path="/ekip" element={<ProtectedRoute><Layout><TeamPage /></Layout></ProtectedRoute>} />
              <Route path="/destek" element={<ProtectedRoute><Layout><TicketsPage /></Layout></ProtectedRoute>} />
              <Route path="/destek/:tid" element={<ProtectedRoute><Layout><TicketDetailPage /></Layout></ProtectedRoute>} />
              <Route path="/mesajlar" element={<ProtectedRoute><Layout><MessagesPage /></Layout></ProtectedRoute>} />
              <Route path="/bildirimler" element={<ProtectedRoute><Layout><NotificationsPage /></Layout></ProtectedRoute>} />
              <Route path="/finans" element={<ProtectedRoute requireAdmin><Layout><FinancePage /></Layout></ProtectedRoute>} />
              <Route path="/toplantilar" element={<ProtectedRoute><Layout><MeetingsPage /></Layout></ProtectedRoute>} />
              <Route path="/takvim" element={<ProtectedRoute><Layout><CalendarPage /></Layout></ProtectedRoute>} />
              <Route path="/notlar" element={<ProtectedRoute><Layout><NotesPage /></Layout></ProtectedRoute>} />
              <Route path="/onboarding" element={<ProtectedRoute><Layout><OnboardingPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar" element={<ProtectedRoute><Layout><AiToolsIndexPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/anahtar-kelime" element={<ProtectedRoute><Layout><KeywordToolPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/anahtar-kelime/listeler" element={<ProtectedRoute><Layout><KeywordListsPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/anahtar-kelime/listeler/:listId" element={<ProtectedRoute><Layout><KeywordListDetailPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/anahtar-kelime/yeni" element={<ProtectedRoute><Layout><KeywordNewJobPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/anahtar-kelime/:jobId" element={<ProtectedRoute><Layout><KeywordJobDetailPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/reklam-metni" element={<ProtectedRoute><Layout><AdCopyToolPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/reklam-metni/yeni" element={<ProtectedRoute><Layout><AdCopyNewPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/reklam-metni/:jobId" element={<ProtectedRoute><Layout><AdCopyJobDetailPage /></Layout></ProtectedRoute>} />
              <Route path="/ai-araclar/indexboost" element={<ProtectedRoute><Layout><IndexBoostPage /></Layout></ProtectedRoute>} />
              <Route path="/raporlar/:reportId" element={<ProtectedRoute><Layout><ReportBuilderPage /></Layout></ProtectedRoute>} />
              <Route path="/yonetim" element={<ProtectedRoute requireAdmin><Layout><AdminSettingsPage /></Layout></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        } />
        {/* Customer portal */}
        <Route path="/portal/login" element={
          <PortalAuthProvider><PortalLoginPage /></PortalAuthProvider>
        } />
        <Route path="/portal/*" element={
          <PortalAuthProvider>
            <Routes>
              <Route path="/" element={<PortalProtectedRoute><PortalLayout><PortalDashboard /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/hizmet/:sid" element={<PortalProtectedRoute><PortalLayout><PortalServiceDetail /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/dosyalar" element={<PortalProtectedRoute><PortalLayout><PortalFiles /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/destek" element={<PortalProtectedRoute><PortalLayout><PortalSupport /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/destek/:tid" element={<PortalProtectedRoute><PortalLayout><PortalTicketDetail /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/anahtar-kelimeler" element={<PortalProtectedRoute><PortalLayout><PortalKeywords /></PortalLayout></PortalProtectedRoute>} />
              <Route path="/raporlar" element={<PortalProtectedRoute><PortalLayout><PortalReports /></PortalLayout></PortalProtectedRoute>} />
              <Route path="*" element={<Navigate to="/portal/" replace />} />
            </Routes>
          </PortalAuthProvider>
        } />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
